export default "/images/project-playstation-main.png";